import {SpinnerStatusContext} from "components/src/context/SpinnerStatusContextProvider";
import {useContext} from 'react'

export function useSpinnerStatusContext()
{
    const context = useContext(SpinnerStatusContext);

    if (!context) {
        throw new Error(
            "useSpinnerStatusContext must be used within the scope of SpinnerStatusContextProvider"
        );
    }

    return context;
}